import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const FieldLabel = styled.code`
  border: ${props => props.theme.borderMd};
  border-radius: 3px;
  padding: 4px;
  font-size: 15px;
  color: ${props => props.theme.primary};
`;

function HitDescription({
  explanation: {
    model: { score, threshold: modelThreshold, type },
    override,
    threshold,
  },
  listMetadata: {
    list_name
  },
  hit_field,
}) {
  if (override && override.type) {
    if (override.decision === 0) {
      return <span>Auto-clear rule triggered</span>;
    } else {
      return (
        <span>
          Auto-escalate rule triggered on <FieldLabel>{hit_field}</FieldLabel>
        </span>
      );
    }
  }

  // TODO finalize
  const overThreshold = score >= modelThreshold;
  if (threshold && threshold.decision) {
    return (
      <span>
        Field threshold met for <FieldLabel>{hit_field}</FieldLabel>
      </span>
    );
  }

  return (
    <span>
      Match likelihood threshold {overThreshold ? 'met' : 'not met'} for{' '}
      <FieldLabel>{hit_field}</FieldLabel>
    </span>
  );
}

HitDescription.propTypes = {
  hit_field: PropTypes.string.isRequired,
  explanation: PropTypes.shape({
    override: PropTypes.shape({
      decision: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }),
    model: PropTypes.shape({
      model_type: PropTypes.string.isRequired,
      score: PropTypes.number,
      feature_explanation: PropTypes.arrayOf({
        name: PropTypes.string,
        value: PropTypes.number,
        description: PropTypes.string,
      }).isRequired,
    }),
    threshold: PropTypes.shape({
      type: PropTypes.string.isRequired,
      decision: PropTypes.number.isRequired,
      minimum_score: PropTypes.number.isRequired,
      score: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default HitDescription;
